import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

export default function AppLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden bg-medical-50" data-testid="app-layout">
            <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            <main className="flex-1 flex flex-col h-full overflow-hidden relative">
                <TopBar onOpenSidebar={() => setSidebarOpen(true)} />
                <Outlet />
            </main>
        </div>
    );
}
